/** Título del módulo admin según la ruta actual (barra superior). */

const EXACT = {
  '/admin': 'Dashboard',
  '/admin/pedidos': 'Pedidos',
  '/admin/comanda': 'Comanda',
  '/admin/caja': 'Caja',
  '/admin/cocina': 'Cocina',
  '/admin/repartidores': 'Repartidores',
  '/admin/menu': 'Menú',
  '/admin/almacen': 'Almacén',
  '/admin/horarios': 'Horarios',
  '/admin/config-tienda': 'Config tienda',
  '/admin/cupones': 'Cupones',
  '/admin/whatsapp': 'WhatsApp',
  '/admin/settings': 'Ajustes',
  '/admin/sitio-publico': 'Sitio Público',
  '/admin/administradores': 'Personal',
  '/admin/productos': 'Productos',
  '/admin/citas': 'Citas',
  '/admin/citas/por-confirmar': 'Citas por confirmar',
  '/admin/resenas': 'Reseñas',
};

const PREFIX = [
  ['/admin/cocina', 'Cocina'],
  ['/admin/pedidos', 'Pedidos'],
  ['/admin/repartidores', 'Repartidores'],
  ['/admin/menu', 'Menú'],
  ['/admin/almacen', 'Almacén'],
  ['/admin/citas/por-confirmar', 'Citas por confirmar'],
  ['/admin/citas', 'Citas'],
  ['/admin/sitio-publico', 'Sitio Público'],
  ['/admin/administradores', 'Personal'],
];

export function adminModuleTitle(pathname) {
  const p = pathname || '';
  if (EXACT[p]) return EXACT[p];
  for (const [prefix, title] of PREFIX) {
    if (p === prefix || p.startsWith(`${prefix}/`)) return title;
  }
  if (p.startsWith('/admin')) return 'Panel';
  return '';
}
